import { listicleItems } from "@/mocks/home-data";
import SectionHeading from "./SectionHeading";

export default function QingdanModule() {
  return (
    <section id="qingdan" className="border-t border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          kicker="吃瓜清单 · 本周必吃"
          title={<>本周吃瓜清单，按顺序吃到尾</>}
          desc="从一雷到四雷按热度排序，四张封面瓜配好入口顺序，想吃哪只点哪只，别中途串线。"
          right={
            <a
              href="#baoliao"
              className="inline-flex items-center gap-1.5 whitespace-nowrap font-label text-sm font-semibold text-primary-600 hover:text-primary-700"
            >
              更多爆料汇总 <i className="ri-arrow-right-line" />
            </a>
          }
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {listicleItems.map((item) => (
            <a
              key={item.rank}
              href="#mailuo"
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-100/60 transition-colors hover:border-primary-300"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={item.title}
                  className="h-52 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-foreground-950/80 px-2 py-1 font-label text-xs font-bold text-background-50">
                  {item.rank}
                </span>
                <span className="absolute right-3 top-3 rounded-md bg-accent-500 px-2 py-1 font-label text-[11px] font-semibold text-background-50">
                  {item.label}
                </span>
              </div>
              <div className="p-4">
                <h3 className="display-serif text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {item.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-6 text-foreground-600">{item.lead}</p>
                <p className="mt-3 flex items-center gap-1.5 font-label text-[11px] font-medium text-secondary-600">
                  <i className="ri-chat-3-line text-xs" /> {item.meta}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}